import React, { Component } from 'react';

import PropTypes from 'prop-types';
import FaExternalLink from 'react-icons/lib/fa/external-link';

import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import locationIcon from 'wanderu-assets/images/location-icon.svg';
import {
    GOOGLE_DIRECTIONS_URL,
    GOOGLE_SEARCH_URL,
} from 'wanderu-service-google/src/Constants';

import {
    getMapWindowFeatures,
} from '../../utils/mapWindow';

import styles from './DirectionsMap.scss';

class DirectionsMap extends Component {
    popUpWindow = undefined;

    static propTypes = {
        arriveLoading: PropTypes.bool,
        arriveStation: PropTypes.shape({
            loc: PropTypes.shape({
                lat: PropTypes.number,
                lng: PropTypes.number,
            }),
        }),
        arriveStationId: PropTypes.string,
        arriveSuccess: PropTypes.bool,
        buttonText: PropTypes.string,
        className: PropTypes.string,
        departLoading: PropTypes.bool,
        departStation: PropTypes.shape({
            loc: PropTypes.shape({
                lat: PropTypes.number,
                lng: PropTypes.number,
            }),
        }),
        departStationId: PropTypes.string.isRequired,
        departSuccess: PropTypes.bool,
        fetchStationDetails: PropTypes.func.isRequired,
        isMobileButton: PropTypes.bool,
        labelClassName: PropTypes.string,
        trackEvent: PropTypes.func,
        waypointType: PropTypes.string,
    };

    static defaultProps = {
        arriveLoading: false,
        arriveStation: null,
        arriveStationId: null,
        arriveSuccess: false,
        buttonText: '',
        className: '',
        departLoading: false,
        departStation: null,
        departSuccess: false,
        isMobileButton: false,
        labelClassName: null,
        trackEvent() { },
        waypointType: '',
    };

    componentDidUpdate(prevProps) {
        const {
            arriveLoading,
            arriveSuccess,
            departLoading,
            departSuccess,
        } = this.props;

        const {
            arriveLoading: prevArriveLoading,
            departLoading: prevDepartLoading,
        } = prevProps;

        if (
            !this.popUpWindow
            || arriveLoading
            || departLoading
        ) {
            return;
        }

        if (
            (
                prevDepartLoading
                && departSuccess
            ) || (
                prevArriveLoading
                && arriveSuccess
            )
        ) {
            this.populateMapWindow();
        }
    }

    fetchStationData() {
        const {
            departStation,
            departStationId,
            arriveStation,
            arriveStationId,
            fetchStationDetails,
        } = this.props;

        if (!!departStationId && !departStation) {
            fetchStationDetails(departStationId);
        }

        if (!!arriveStationId && !arriveStation) {
            fetchStationDetails(arriveStationId);
        }
    }

    buildUrl() {
        const {
            departStation,
            arriveStation,
        } = this.props;

        const originLatLong = `${departStation.loc.lat},${departStation.loc.lng}`;
        let externalUrl = `${GOOGLE_SEARCH_URL}&query=${originLatLong}`;

        if (arriveStation) {
            const destinationLatLong = `${arriveStation.loc.lat},${arriveStation.loc.lng}`;
            const directionUrl = `&origin=${originLatLong}&destination=${destinationLatLong}`;

            externalUrl = `${GOOGLE_DIRECTIONS_URL}${directionUrl}`;
        }

        return externalUrl;
    }

    buildMapWindow() {
        const windowFeatures = getMapWindowFeatures();

        return window.open('about:blank', 'locationMap', windowFeatures);
    }

    populateMapWindow() {
        this.popUpWindow.location = this.buildUrl();

        this.popUpWindow = undefined;
    }

    handleClick = (event) => {
        // prevents tapping on the map icon from selecting the trip in mobile
        event.stopPropagation();

        const {
            arriveStation,
            arriveStationId,
            departStation,
            trackEvent,
        } = this.props;

        trackEvent();

        this.popUpWindow = this.buildMapWindow();

        if (
            !departStation
            || (
                !!arriveStationId
                && arriveStation === null
            )
        ) {
            return this.fetchStationData();
        }

        this.populateMapWindow();
    };

    render() {
        const {
            buttonText,
            className,
            labelClassName,
            isMobileButton,
            t,
            waypointType,
        } = this.props;

        const label = labelClassName
            ? <span className={labelClassName}>{buttonText}</span>
            : buttonText;

        return isMobileButton
            ? (
                <Button
                    className={`${styles.pin} ${styles[waypointType]}`}
                    type="button"
                    unstyled
                >
                    <img
                        alt={t('baseApp:map')}
                        onClick={this.handleClick}
                        src={locationIcon}
                    />
                </Button>
            )
            : (
                <Button
                    className={className}
                    onClick={this.handleClick}
                    type="button"
                    unstyled
                >
                    {label} <FaExternalLink className={styles.externalLinkIcon} />
                </Button>
            );
    }
}

export { DirectionsMap };
export default localize(DirectionsMap, ['t'], 'baseApp');
